import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuEventService {

    private _newSalesFlowSelection = new Subject<void>();  
    newSalesFlowSelection$ = this._newSalesFlowSelection.asObservable();  

    newSalesFlowSelection(): void {
        this._newSalesFlowSelection.next(); 
    }

    private _salesFlowSelection = new Subject<void>();  
    salesFlowSelection$ = this._salesFlowSelection.asObservable();  

    salesFlowSelection(): void {
        this._salesFlowSelection.next();
    }

}